import React from "react";
import { useDisclosureContext } from "./disclosure-context.js";

/* DisclosureCaret — the glyph that TURNS (ADR-0091).

   One element, rotated 90° by `pb-disclosure-caret` when the disclosure is
   open. Two glyphs swapped for each other are two different elements with
   nothing for a transition to interpolate between, which is why the old
   carets snapped. Pass a right-pointing chevron; open, it points down. */

export interface DisclosureCaretProps {
  /** The glyph, e.g. a right-pointing chevron. */
  children: React.ReactNode;
}

export function DisclosureCaret({ children }: DisclosureCaretProps) {
  const { open } = useDisclosureContext("DisclosureCaret");
  return (
    <span
      aria-hidden
      data-expanded={open ? "true" : "false"}
      className="pb-disclosure-caret inline-flex shrink-0"
    >
      {children}
    </span>
  );
}
